// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import Request from './request';

async function fetch(data) {//银行账号金额汇总
    return Request('get', "api/sub-account-analyses", data);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/sub-account-analyses/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/sub-account-analyses/" + id, data);
}

async function exportOne(id, data) {// 导出单个的报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/sub-account-analyses/export-detail/" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function batchExportDetail(data) {
    // 批量导出报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/sub-account-analyses/export-for-material', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function fetchOrders(data) {//分账结算查询
    return Request('get', "api/sub-account-analyses/sub_account_orders", data);
}

async function batchExportOrdersDetail(data) {
    // 批量导出报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/sub-account-analyses/sub-account-order-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function fetchOrder(id) {// 获取单个
    return Request('get', "api/sub-account-analyses/sub-account-order-view/" + id);
}

async function fetchOrderForSubAccount(id) {// 获取单个
    return Request('get', "api/sub-account-analyses/sub-account-order-dialog/" + id);
}

async function exportsOrder(id,data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/sub-account-analyses/sub-account-order-view-export/" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function billNoPayExport(data) {// 导出账单分账汇总
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/sub-account-analyses/bill-no-pay-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function billDetailExport(data) {// 导出欠款账单汇总
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/sub-account-analyses/bill-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

export default {
    fetch,
    exports,
    fetchOne,
    exportOne,
    batchExportDetail,
    fetchOrders,
    batchExportOrdersDetail,
    fetchOrder,
    exportsOrder,
    fetchOrderForSubAccount,
    billNoPayExport,
    billDetailExport,
};